"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleLogDividerVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class BattleLogDividerVfxStepArgs {
    constructor(text = "") {
        this.text = text;
        this.__typeName = "BattleLogDivider";
        this.id = (0, uuid_1.v4)();
    }
}
exports.BattleLogDividerVfxStepArgs = BattleLogDividerVfxStepArgs;
